import { render } from "./internet-banking.vue?vue&type=template&id=3fec5fb0"
import script from "./internet-banking.vue?vue&type=script&lang=js"
export * from "./internet-banking.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__